import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import { getProposalSummary } from "store/actions/proposals";
import DashboardView from "containers/DashboardView";
import StartNewProposal from "components/StartNewProposal";
import { proposalListSelectors } from "store/selectors";
import LoadingIndicator from "@cayuse/shared-react.components.loading-indicator";


const ProposalDashboard = ({ dashboardTilesAriaControls, searchFacets, onSearchChange, actualFacets }) => {
	const [ activeSummary, setActiveSummary ] = useState(null);
	const { search } = useSelector(proposalListSelectors.content);
	const { items, isFetching } = useSelector(proposalListSelectors.summary);

	useEffect(() => {
		getProposalSummary();
	}, []);

	useEffect(() => {
		if (search?.Status) {
			setActiveSummary(search?.Status);
		} else {
			setActiveSummary(null);
		}
	}, [ search ]);

	const onTileClick = value => {
		const activeSearch = search && search.val !== value
			? { Status: value }
			: {};
		const selectedFacets = actualFacets;
		selectedFacets.status = `"${value.toLowerCase()}"`;
		onSearchChange({ facetSearch: selectedFacets, facets: searchFacets });
		const activeSummary = isNonEmptyString(activeSearch.Status) ? activeSearch.Status : null;

		setActiveSummary(activeSummary);
	};

	if (isFetching) {
		return <LoadingIndicator />;
	}

	const headerButtons = [
		<StartNewProposal key="startNewProposal" />
	];

	return (
		<>
			<h3 className="accessibility-text">Proposals</h3>
			<p className="accessibility-text">
				Use the buttons to filter the list of proposals by status.
			</p>
			<DashboardView summary={items}
				onTileClick={onTileClick}
				activeTile={activeSummary}
				headerButtons={headerButtons}
				dashboardTopic="proposals"
				dashboardTilesAriaControls={dashboardTilesAriaControls}
			/>
		</>
	);
};

ProposalDashboard.propTypes = {
	dashboardTilesAriaControls: PropTypes.string
};

export default ProposalDashboard;
